import './projects.less';

// trim-below
import React from 'react';
import PropTypes from 'prop-types';
import block from 'bem-cn-lite';

const b = block('projects');

const ProjectItem = ({title, location, summary, imagePath, imagePath2x, imageText}) => (
	<div className={b('item')}>
		<div className={b('container')}>
			<img className={b('img')}
				srcSet={`${imagePath} 300w, ${imagePath2x} 620w`}
				sizes="(max-width: 960px) 620px, 300px"
				src={imagePath}
				alt={imageText}
			/>
			<div className={b('content')}>
				{
					title &&
					<h3 className={b('title')}>{title}</h3>
				}
				{
					location &&
					<p className={b('location')}>{location}</p>
				}
				{
					summary &&
					<p className={b('text')}>{summary}</p>
				}
			</div>
		</div>
	</div>
);

ProjectItem.propTypes = {
	title: PropTypes.string.isRequired,
	location: PropTypes.string,
	summary: PropTypes.string,
	imagePath: PropTypes.string.isRequired,
	imagePath2x: PropTypes.string.isRequired,
	imageText: PropTypes.string
};

export default ProjectItem;



// WEBPACK FOOTER //
// ./src/components/projects/project-item.jsx